var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-header__button"},[_c('v-btn',{attrs:{"text":"","ripple":"","color":'#fff',"to":_vm.link}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"top-header__button-text"},[_vm._v(_vm._s(_vm.text))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }